import React from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'

import {
  required,
  validateEmail,
  composeValidators,
} from '../../utils/validation'
import TextInput from '../../components/TextInput/index'
import Modal from '../Modal'
import Button from '../../components/Button'
import { flexBoxStyles } from '../../components/Flexbox'

export const MailModal = ({ onClose, isOpen, onSubmit }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title="Wyślij raport mailem"
  >
    <Form onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <>
          <Field
            component={TextInput}
            label="Email"
            name="email"
            validate={composeValidators(required, validateEmail)}
          />
          <Footer justify="space-between">
            <Button label="Wyślij" type="submit" onClick={handleSubmit} />
          </Footer>
        </>
      )}
    </Form>
  </Modal>
)

export const ReportErrorModal = ({ onClose, isOpen, message }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title="Wystąpił błąd podczas generowania raportu."
  >
    <p>{message}</p>
    <Footer justify="space-between">
      <Button color="white" label="Zamknij" marginLeft onClick={onClose} />
    </Footer>
  </Modal>
)

const Footer = styled.div`
  ${flexBoxStyles};
  &::before {
    position: absolute;
    left: 0;
    bottom: 7rem;
    content: '';
    border-bottom: 1px solid #eee;
    width: 100%;
  }
`

export default MailModal
